import { z } from 'zod';

/**
 * Schema for content editing form
 * Supports Title, Bullets, and Description editing
 */
export const ContentFormSchema = z.object({
  currentContent: z.object({
    title: z.string().optional(),
    bullets: z.array(z.string()).optional(),
    description: z.string().optional()
  }),
  generatedContent: z.object({
    title: z.string().optional(),
    bullets: z.array(z.string()).optional(),
    description: z.string().optional()
  })
});

export type ContentForm = z.infer<typeof ContentFormSchema>;

/**
 * Helper to extract plain text from KeywordContent phrases
 */
export const extractPlainText = (phrases: any[]): string => {
  if (!phrases || phrases.length === 0) return '';
  return phrases.map((p) => p.phrase || '').join(' ');
};

/**
 * Helper to convert section data to form values
 */
export const sectionsToFormValues = (
  phrasesKeywords: Record<string, { phrases: any[] }>
): { title?: string; bullets?: string[]; description?: string } => {
  const title = phrasesKeywords?.Title?.phrases ? extractPlainText(phrasesKeywords.Title.phrases) : undefined;
  
  const bullets: string[] = [];
  let bulletIndex = 1;
  while (phrasesKeywords?.[`Bullet ${bulletIndex}`]) {
    const bulletText = extractPlainText(phrasesKeywords[`Bullet ${bulletIndex}`].phrases);
    if (bulletText) bullets.push(bulletText);
    bulletIndex++;
  }
  
  const description = phrasesKeywords?.Description?.phrases
    ? extractPlainText(phrasesKeywords.Description.phrases)
    : undefined;

  return {
    title: title || undefined,
    bullets: bullets.length > 0 ? bullets : undefined,
    description: description || undefined
  };
};

